import { Snapshot } from 'app/agriculture/queries/snapshots/types/Snapshot';
import { Duration, isAfter, isBefore, isWithinInterval, sub as subDuration } from 'date-fns';

interface Options {
    shelfLife?: Duration | null;
    cursorTime?: Date;
}

/** we filter out snapshots that are not within one shelf life of cursorTime */
export function filterSnapshots<T extends Snapshot>(
    snapshots: T[],
    { shelfLife = null, cursorTime }: Options,
): T[] {
    // if there is no shelfLife, we need to filter out snapshots after cursorTime
    if (!shelfLife) {
        // if there is no shelfLife or cursorTime, then why are we here?
        if (!cursorTime) return snapshots;

        return snapshots.filter(({ timestamp }) => isBefore(timestamp, cursorTime));
    }

    // if there is no cursorTime, we need to filter out snapshots from before one shelfLife ago
    if (!cursorTime) {
        return snapshots.filter(({ timestamp }) =>
            isAfter(timestamp, subDuration(new Date(), shelfLife)),
        );
    }

    // if there is both a cursorTime and a shelfLife
    // we filter out snapshots that aren't within a shelfLife of cursor time
    return snapshots.filter(({ timestamp }) =>
        isWithinInterval(timestamp, {
            /** if there is no shelfLife, the 'shelf' starts at the beginning of time */
            start: subDuration(cursorTime, shelfLife),
            /** this also filters out any snapshots that are after cursorTime */
            end: cursorTime,
        }),
    );
}
